import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { DialogGuestPortalTasksComponent } from '@app/shared/components/dialog-guest-portal-tasks/dialog-guest-portal-tasks.component';
import { Reservation } from '@app/shared/interfaces';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { VerificationRatingStatus } from '@app/shared/services/guest-portal/guest-portal.service';
import { SelectedReservationService } from '@app/shared/services/selected-reservation.service';
import { MessageReservation } from '@app/shared/services/thread/thread.service';
import { map } from 'rxjs';

@Component({
  selector: 'sbnb-booking-request',
  templateUrl: './booking-request.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingRequestComponent implements OnInit {
  @Input() message: MessageReservation;
  @Input() reservation: Reservation;
  @Input() acceptLoading: boolean;
  @Input() rejectLoading: boolean;
  @Output() accept = new EventEmitter();
  @Output() reject = new EventEmitter();

  startDate: string;
  endDate: string;

  isMobile = toSignal(this.deviceDetectionService.isMobileViewport());

  constructor(
    private selectedReservationService: SelectedReservationService,
    private dialog: MatLegacyDialog,
    private deviceDetectionService: DeviceDetectionService
  ) {}

  guestVettingData$ = this.selectedReservationService.guestVetting$;
  requiresReviewBeforeAcceptance$ = this.guestVettingData$.pipe(
    map((guestVettingData) => {
      return guestVettingData?.status === VerificationRatingStatus.SUSPECTED;
    })
  );

  ngOnInit(): void {
    if (!this.message) return;
    this.startDate = this.message.start_date?.split('T')[0];
    this.endDate = this.message.end_date?.split('T')[0];
  }

  review() {
    this.dialog.open(DialogGuestPortalTasksComponent, {
      data: {
        initialTab: 'guest-verification',
        reservation: this.reservation,
        propertyId: this.reservation.listing.property_id,
      },
      width: this.isMobile() ? '100%' : '80vw',
      height: this.isMobile() ? '100%' : '80vh',
      maxWidth: this.isMobile() ? '100vw' : '80vw',
      panelClass: 'dialog-guest-portal-tasks',
    });
  }
}
